"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DenseTableModule = _interopRequireDefault(require("../../../styles/components/DeviceTable/DenseTable.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DenseTable = props => {
  const {
    header = [],
    children,
    customStyles
  } = props;
  return /*#__PURE__*/React.createElement(_material.TableContainer, {
    component: _material.Paper,
    className: "".concat(_DenseTableModule.default.table_wrap, " ").concat(customStyles ? _DenseTableModule.default.flushingInfoContainer : '')
  }, /*#__PURE__*/React.createElement(_material.Table, {
    size: "small",
    "aria-label": "a dense table",
    className: _DenseTableModule.default.table
  }, /*#__PURE__*/React.createElement(_material.TableHead, null, /*#__PURE__*/React.createElement(_material.TableRow, null, header.map(function () {
    let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let i = arguments.length > 1 ? arguments[1] : undefined;
    if (h.showIf !== undefined && !h.showIf) return null;
    return /*#__PURE__*/React.createElement(_material.TableCell, {
      key: i,
      align: h.align || 'center',
      style: h.style
    }, h.text || '');
  }))), /*#__PURE__*/React.createElement(_material.TableBody, null, children)));
};
var _default = exports.default = DenseTable;